import type { DocumentNode, FragmentDefinitionNode } from "graphql";
import { print } from "graphql";

// TODO: remove this after https://github.com/apollographql/graphql-tag/pull/244 is released
export function firstFragmentName(queryFragment: DocumentNode): string {
  const definitions = queryFragment.definitions as ReadonlyArray<FragmentDefinitionNode>;
  const name = definitions[0].name.value;

  if (!name) {
    throw new Error(`No fragment name in ${print(queryFragment)}`);
  }

  return name;
}
